var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormazione(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0213 30C9.35259 30 8 31.399 8 33.1249C8 34.8507 9.35287 36.25 11.0213 36.25H34.25V30H11.0213Z",
    fill: "#EFEDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0552 36.1244C9.40932 36.1244 8.07525 34.764 8.07525 33.0863C8.07525 31.408 9.4096 30.0479 11.0552 30.0479H34.2125C34.9236 30.0479 35.5 29.46 35.5 28.735V2.56292C35.5 1.83765 34.9236 1.25 34.2125 1.25H10.6651C7.81231 1.25 5.5 3.60777 5.5 6.516V33.484C5.5 36.3922 7.81259 38.75 10.6651 38.75H34.2125C34.9236 38.75 35.5 38.1623 35.5 37.4371C35.5 36.7121 34.9236 36.1244 34.2125 36.1244H11.0552Z",
    fill: "#FD6F71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2125 36.1244H11.0552C9.40932 36.1244 8.07525 34.764 8.07525 33.0863C8.07525 31.408 9.4096 30.0479 11.0552 30.0479H12.5596V1.25H10.6651C7.81231 1.25 5.5 3.60777 5.5 6.516V33.484C5.5 36.3922 7.81259 38.75 10.6651 38.75H34.2125C34.9236 38.75 35.5 38.1623 35.5 37.4371C35.5 36.7121 34.9236 36.1244 34.2125 36.1244Z",
    fill: "#FD6F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormazione);
export default __webpack_public_path__ + "static/media/formazione.9660d3201dba9785fd8564ed5ff5410c.svg";
export { ForwardRef as ReactComponent };